/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h as headingLevelOptions } from './level-Cj2m5HKt.js';
import { b as watchValidator } from './common-D-vggmh2.js';

const watchHeadingLevel = (component, value) => {
    watchValidator(component, '_level', (value) => typeof value === 'number' && headingLevelOptions.includes(value), new Set(headingLevelOptions.map(String)), value, {
        defaultValue: 1,
        required: true,
    });
};

export { watchHeadingLevel as w };
//# sourceMappingURL=validation-Cnndf99L.js.map

//# sourceMappingURL=validation-Cnndf99L.js.map